// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}
.primary {
    color: #007bff;
}
.App-logo {
    height: 40vmin;
    pointer-events: none;
}

.btn-black {
    background-color: black;
    color: white;
}

.btn-black:hover {
    background-color: black;
    color: white;
    box-shadow: 0 0 10px #1b1b1b;
}

.btn-custom-1 {
    background-color: white;
    color: #007bff;
    border: 2px solid #007bff;
    transition: border-color 0.3s, box-shadow 0.3s; /* Smooth transition */
}

.btn-custom-1:hover {
    border-color: #64abf7;
    box-shadow: 0 0 10px #64abf7;
}

.registration-header {
    color: #007bff !important;
    padding: 0 !important;
    margin-bottom: 25px;
    font-size: 36px;
}

.btn-custom-2 {
    border-color: rgb(230, 8, 8);
    box-shadow: 0 0 10px rgb(230, 8, 8);
}

.fm-label-right {
    margin-right: 72% !important;
    text-align: left !important;
}

.btn-custom-2 :hover {
    border-color: rgb(230, 8, 8);
    box-shadow: 0 0 10px rgb(230, 8, 8);
}

/* Custom CSS for the circled cross icon */
.error-icon {
    display: inline-block;
    width: 1.7vw;
    height: 2.7vh;
    border: 2px solid red;
    border-radius: 50%;
    background-color: white;
    color: red;
    font-weight: bold;
    line-height: 2vh;
    text-align: center;
}

.cross-icon {
    position: relative;
    top: 1px;
    font-weight: bold;
}

.password-input-container {
    position: relative;
}

.btn {
    height: 6vh !important;
    align-content: center;
}

.password-toggle-icon {
    position: absolute;
    top: 50%;
    right: 0.8vw;
    transform: translateY(-50%);
    cursor: pointer;
}

.card.no-border {
    border: none;
    box-shadow: 10px #f5f2f2;
}

.card-body {
    width: 80% !important;
}

.card-header.no-border {
    border-bottom: none;
    background-color: white;
}

.card-header.text-center {
    text-align: center;
    color: #007bff;
}

.form-control {
    border-radius: 0.175rem !important;
    height: 6vh;
    margin: 0 auto;
}

.form-label {
    /* display: inline-block;
    width: 70%; 
    height: 6vh;
    margin: 0 auto;  */
}

.form-group {
    margin-bottom: 1rem;
}

.btn-group {
    display: flex;
    justify-content: center;
}

.btn-group .btn {
    width: 70%; /* Match the width of form controls */
    margin: 0 auto; /* Center the buttons */
}

.register-card-body {
    width: 100% !important;
}

.ml-6 {
    margin-left: 6vw !important;
    margin-right: 6vw !important;
}

p {
    margin-top: 0;
    margin-bottom: 0rem;
}

@media (max-width: 768px) {
    .form-control {
        width: 90%; /* Adjust width for smaller screens */
    }

    .card-body {
        width: 100% !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/register/register.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,8CAA8C,EAAE,sBAAsB;AAC1E;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA,0CAA0C;AAC1C;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;;;sBAGkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU,EAAE,qCAAqC;IACjD,cAAc,EAAE,uBAAuB;AAC3C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU,EAAE,qCAAqC;IACrD;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".App {\n    text-align: center;\n}\n.primary {\n    color: #007bff;\n}\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n.btn-black {\n    background-color: black;\n    color: white;\n}\n\n.btn-black:hover {\n    background-color: black;\n    color: white;\n    box-shadow: 0 0 10px #1b1b1b;\n}\n\n.btn-custom-1 {\n    background-color: white;\n    color: #007bff;\n    border: 2px solid #007bff;\n    transition: border-color 0.3s, box-shadow 0.3s; /* Smooth transition */\n}\n\n.btn-custom-1:hover {\n    border-color: #64abf7;\n    box-shadow: 0 0 10px #64abf7;\n}\n\n.registration-header {\n    color: #007bff !important;\n    padding: 0 !important;\n    margin-bottom: 25px;\n    font-size: 36px;\n}\n\n.btn-custom-2 {\n    border-color: rgb(230, 8, 8);\n    box-shadow: 0 0 10px rgb(230, 8, 8);\n}\n\n.fm-label-right {\n    margin-right: 72% !important;\n    text-align: left !important;\n}\n\n.btn-custom-2 :hover {\n    border-color: rgb(230, 8, 8);\n    box-shadow: 0 0 10px rgb(230, 8, 8);\n}\n\n/* Custom CSS for the circled cross icon */\n.error-icon {\n    display: inline-block;\n    width: 1.7vw;\n    height: 2.7vh;\n    border: 2px solid red;\n    border-radius: 50%;\n    background-color: white;\n    color: red;\n    font-weight: bold;\n    line-height: 2vh;\n    text-align: center;\n}\n\n.cross-icon {\n    position: relative;\n    top: 1px;\n    font-weight: bold;\n}\n\n.password-input-container {\n    position: relative;\n}\n\n.btn {\n    height: 6vh !important;\n    align-content: center;\n}\n\n.password-toggle-icon {\n    position: absolute;\n    top: 50%;\n    right: 0.8vw;\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.card.no-border {\n    border: none;\n    box-shadow: 10px #f5f2f2;\n}\n\n.card-body {\n    width: 80% !important;\n}\n\n.card-header.no-border {\n    border-bottom: none;\n    background-color: white;\n}\n\n.card-header.text-center {\n    text-align: center;\n    color: #007bff;\n}\n\n.form-control {\n    border-radius: 0.175rem !important;\n    height: 6vh;\n    margin: 0 auto;\n}\n\n.form-label {\n    /* display: inline-block;\n    width: 70%; \n    height: 6vh;\n    margin: 0 auto;  */\n}\n\n.form-group {\n    margin-bottom: 1rem;\n}\n\n.btn-group {\n    display: flex;\n    justify-content: center;\n}\n\n.btn-group .btn {\n    width: 70%; /* Match the width of form controls */\n    margin: 0 auto; /* Center the buttons */\n}\n\n.register-card-body {\n    width: 100% !important;\n}\n\n.ml-6 {\n    margin-left: 6vw !important;\n    margin-right: 6vw !important;\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 0rem;\n}\n\n@media (max-width: 768px) {\n    .form-control {\n        width: 90%; /* Adjust width for smaller screens */\n    }\n\n    .card-body {\n        width: 100% !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
